import L from 'leaflet'
import Utils from 'utils'

const numberIcon = (
  item: any,
  isInArea: boolean,
  isSelected?: boolean,
  isShowNumbers?: boolean
) => {
  const icon = L.divIcon({
    className: `rounded-full !w-8 !h-8 flex ${
      item.order < 100 ? 'text-base' : 'text-sm'
    }  !-mt-[16px] !-ml-[16px] ${Utils.getPointColor(
      item,
      isInArea,
      isSelected
    )}`,
    html: `<div style="margin:auto; display: ${
      isShowNumbers === false ? 'none' : 'block'
    }">${item.order ?? '?'}</div>`
  })
  return icon
}

const smallNumberIcon = (
  item: any,
  selectedId?: string,
  isShowNumbers?: boolean
) => {
  const icon = L.divIcon({
    className: `rounded-full !w-[10px] !h-[10px] flex ${
      item.order < 100 ? 'text-[6px]' : 'text-[5px]'
    } text-white ${
      item.id === selectedId ? 'theme-bg-primary' : 'bg-[#021120]'
    }`,

    html: `<div style="margin:auto; display: ${
      isShowNumbers === false ? 'none' : 'block'
    }">${item.order ?? '?'}</div>`
  })
  return icon
}

const rotatedMarkerIcon = (rotationAngle: any) => {
  const icon = new L.DivIcon({
    iconUrl: '/assets/view.png',
    iconAnchor: [35, 50],
    className: 'rotating-marker',
    html: `<img src="/assets/view.png" draggable="false" style="clip-path: polygon(0 0, 50% 100%, 100% 0); height:50px !important; width:70px !important;transform: rotate(${rotationAngle}deg);transform-origin: 50% 100%;" />`
  })
  return icon
}

// create radar icon using in view floor map
const rotatedMarkerViewIcon = (rotationAngle: any) => {
  const icon = new L.DivIcon({
    iconUrl: '/assets/view.png',
    iconAnchor: [17, 23],
    className: 'rotating-marker',
    html: `<img src="/assets/view.png" draggable="false" style="clip-path: polygon(0 0, 50% 100%, 100% 0); height:20px !important; width:30px !important;transform: rotate(${rotationAngle}deg);transform-origin: 50% 100%;" />`
  })
  return icon
}

const rotatedMarkerIconDense = (rotationAngle: any) => {
  const icon = new L.DivIcon({
    iconUrl: '/assets/dense-view.png',
    iconAnchor: [35, 50],
    className: 'rotating-marker',
    html: `<img src="/assets/dense-view.png" draggable="false" style="clip-path: polygon(0 0, 50% 100%, 100% 0); height:50px !important; width:70px !important;transform: rotate(${rotationAngle}deg);transform-origin: 50% 100%;" />`
  })
  return icon
}

export {
  numberIcon,
  smallNumberIcon,
  rotatedMarkerIcon,
  rotatedMarkerIconDense,
  rotatedMarkerViewIcon
}
